<template>
  <div class="pane content-tree" ref="box1" :class="treeWrap" style="min-width:400px;">
    <div class="ly-list tree-view">
      <div class="ly-list-top">
        <div class="ly-title">
          <h3 class="title-sub">
            {{ $t("messages.titRoleTypeList") }}
          </h3>
        </div>
        <div class="ly-filter">
          <idc-input
            v-model="filterKeyword"
            className="funnel"
            :placeholder="$t('messages.plSearch')"
            size="medium"
          />
          <div class="ly-sort">
            <div class="total">
              <span>{{ $t("messages.all") }}</span>
              <span class="total-num"> {{ treeTotalCount }}</span>
            </div>
            <div class="sort">
              <el-button type="filter" class="icon icon-treeCheck" />
              <el-button type="filter" class="icon icon-treeOpen" />
              <el-button type="filter" class="icon icon-treeClose" />
            </div>
          </div>
        </div>
      </div>
      <idc-tree-role 
        ref="idcTreeRole"
        :nodeList="nodeList"
        @nodeClick="selectedRoleInfo"
        :filterText="filterKeyword"
      />
    </div>
  </div>
</template>

<script>
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import commonMixin from "@/mixins/commonMixin";
import IdcTreeRole from '@/components/common/IdcTreeRole.vue';
import IdcInput from "@/components/common/IdcInput.vue";

export default {
  mixins: [commonMixin],
  components: {
    IdcSearchCatalog,
    IdcTreeRole,
    IdcInput
  },
  created() {

  },
  props: {
    
  },
  data() {
    return {
      filterKeyword: "",
      nodeList: [],
    }
  },
  computed: {
    treeTotalCount() {
      return this.nodeList.length;
    }
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    selectedRoleInfo(selectedNode) {
      this.$emit("selectedRole", selectedNode);
    },
    async getRoleList() {
      const req = await this.$BIZ_SERVICE.post(this.$API_URLS.Com.getHierarchyRoleList, {});

      this.nodeList = req.data.resData || [];
    },
  }
}
</script>

<style lang="scss" scoped>
</style>